import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import './css/common.css';

import WebFontLoader from 'webfontloader';
import MainApp from './MainApp';

WebFontLoader.load({
  google: {
    families: ['Roboto:300,400,500,700', 'Material Icons']
  }
});
ReactDOM.render(<MainApp />,document.getElementById('root'));
   


